import appApi from "./api";

export const cotizacionParametrosService = {
  get() {
    return appApi().get("cotizaciones/parametros");
  },

  edit(id) {
    return appApi().get(`cotizaciones/parametros/${id}/edit`);
  },

  update(id, data) {
    return appApi().put(`cotizaciones/parametros/${id}/update`, data);
  },
};
